import { render, staticRenderFns } from "./moaCreate.vue?vue&type=template&id=732ec470&"
import script from "./moaCreate.vue?vue&type=script&lang=js&"
export * from "./moaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports